import React, { useMemo } from 'react';
import { getUserData } from '../../../../../../../services/API';
import getCustomLevelHeaderLogo from './getCustomLevelHeaderLogo';
import './ARMToCustomLevelHeader.scss'
import { Tooltip, tooltipTypes } from '../../../../../../Global/Tooltip';

export default function AMRToCustomLevelHeader({metric}) {

  const customARMLevelMapping = getUserData()?.sorConfig?.customARMLevelMapping;
  const customARMLevelMappingEnabled = customARMLevelMapping && customARMLevelMapping !== 'none' && metric?.toLowerCase() === 'arm';

  if(!customARMLevelMappingEnabled) {
    return null
  }

  const logo = useMemo(() => getCustomLevelHeaderLogo(customARMLevelMapping), [customARMLevelMapping]);

  return <div className='benchmark-header-ARM-custom-mapping'>
    {logo && <div className='__logo'>
        <img src={logo} alt='logo' />
      </div>
    }
    <div>Starting Level</div>
    <Tooltip type={tooltipTypes.customARMLevelMappingHeader} />
  </div>

}